function ManagementIT(props) {
    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">경영</h4>
                <h5 className="recruit_titleline_title">경영IT</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <em className="recruit_bold_text">소프트웨어 개발 역량</em>
                <p className="recruit_subinfo_text">
                    · 서버, 클라이언트(웹/모바일/윈도우), 시스템 프로그래밍 중 1개 이상에 대한 개발 경험<br />
                    · RDBMS, RESTful API에 대한 이해 및 연동 프로그래밍 경험<br />
                    · 리눅스 등 Unix-like 시스템 활용 능력
                </p>
                <em className="recruit_bold_text">사용 기술</em>
                <p className="recruit_subinfo_text">
                    - 백엔드: Java(J2EE), Node.js, Tmax<br />
                    - 프론트엔드: HTML, CSS, JavaScript 표준 웹 기술 기반<br />
                    - 모바일: AOS(Java/Kotlin), iOS(Swift)
                </p>
                <em className="recruit_bold_text">커뮤니케이션 및 태스크 관리 역량</em>
                <p className="recruit_subinfo_text">
                    · SBS 미디어 그룹의 주요 비즈니스 프로세스를 이해하고 업무 담당자와 소통하는 능력<br />
                    · 요구사항에 따라 시스템의 규모와 개발 일정을 산정하고 관리하는 능력
                </p>

            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS 미디어 그룹 전체의 업무 생산성과 효율성 향상을 위한 IT 시스템을 구축하는 소프트웨어 개발팀입니다. <br />
                    자체 구축한 업무 시스템을 기반으로 지속적인 개발을 통해 미디어 업계에 특화된 솔루션을 제공합니다.  <br />
                    전체적인 업무 시스템은 크게 다음과 같이 구분됩니다.
                </p>
                <em className="recruit_bold_text">경영정보, 방송정보시스템
                </em>
                <p className="recruit_subinfo_text">
                    · 인사, 재무, 총무, 구매 등 보편적 경영 관리 시스템<br />
                    · 편성, 제작, 광고 등 미디어 특화 업무 관리 시스템
                </p>
                <em className="recruit_bold_text">보도정보 시스템</em>
                <p className="recruit_subinfo_text">
                    · 언론사로서 정확하고 신속한 보도를 위한 뉴스 정보 관리 시스템
                </p>
                <em className="recruit_bold_text">그룹웨어</em>
                <p className="recruit_subinfo_text">
                    · 전자결재, 조직관리, 메일 등 기업 운영에 필수적인 기반 시스템
                </p>
                <em className="recruit_bold_text">선거정보 관리시스템</em>
                <p className="recruit_subinfo_text">
                    · 대선, 총선, 지방선거 등 주요 선거들의 투/개표 방송 진행을 위한 데이터 처리 시스템
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    직급이나 연차에 상관없이 각자 업무 영역에 본인만의 오너십을 가집니다. <br />
                    본인 주도하에 SBS 미디어 그룹의 업무 전문가들과 소통하고 다른 기술 부서 엔지니어들과의 협업을 진행하는 것은 물론,
                    스스로 단위 시스템을 설계한 뒤 DB와 연결하는 persistence layer부터 UI를 다루는 presentation layer까지 Full Stack으로 직접 구현하게 됩니다. 개발 진행 중에는 향상된 기능과 성능 구현을 위해 팀원들과 토론하고 의견을 공유합니다. 이러한 모든 과정을 통해 문제 해결 능력을 갖춘 개발자로 성장한 뒤, 특화된 IT 개발 전문가 또는 아키텍처로 커리어를 이어가게 됩니다.<br />
                    시스템의 지속적인 확장과 최신 기술 도입을 위해 직무역량 강화 교육을 적극적으로 지원하고 있습니다. 기술적 호기심과 배움을 향한 열정을 바탕으로 팀과 회사에 대한 기여는 물론 성취감과 보람 속에 개인의 커리어도 발전시킬 수 있습니다.
                </p>
            </div>
        </div>
    );

}
export default ManagementIT;

